// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.responseScreen {
  /* width: 100vw;
  height: 100vh;
  top: 0px;
  left: 0px; */
  font-size: 1.5rem;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  cursor: auto;
  margin-top: 10vh;
}

.phrase-identification-header {
  z-index: 9999999;
  font-size: xx-large;
}
.phrase-identification-clickable-categories {
  margin: auto;
  display: flex;
  flex-direction: row;
  align-content: space-between;
  z-index: 9999999;
}

.phrase-identification-category-item {
  display: inline-block;
  padding: 5px;
  border-radius: 7px;
  box-sizing: border-box;
  border: 2px solid rgba(0, 0, 0, 0);
}
.phrase-identification-category-item:hover {
  border-color: black;
  cursor: pointer;
}

.phrase-identification-category-title {
  /* font-size: 1.5em; */
  font-weight: bold;
  /* color: black; */
}

.phrase-identification-item-selected {
  border-color: black;
}

.phrase-identification-item-not-selected {
  border-color: rgba(0, 0, 0, 0);
}

.phrase-identification-item-correct {
  background-color: rgba(0, 128, 0, 0.266);
}

.phrase-identification-item-incorrect {
  background-color: rgba(255, 0, 0, 0.26);
}

.scientist-feedback-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border-color: black;
  border-width: 2px;
  border-style: solid;
  background-color: lightblue;
  visibility: visible;
}
.scientist-feedback-circle-container {
  display: flex;
  flex-direction: row;
  z-index: 9999999;
  height: 100px;

  position: absolute;
  bottom: 0;
  left: calc(50%-50vw);
}

.scientist-feedback-circle-correct {
  background-color: rgba(0, 128, 0, 0.266);
}
.scientist-feedback-circle-incorrect {
  background-color: rgba(255, 0, 0, 0.26);
}
`, "",{"version":3,"sources":["webpack://./components/css/phraseIdentification.css"],"names":[],"mappings":"AAAA;EACE;;;cAGY;EACZ,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;;EAEb,kBAAkB;EAClB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;AACA;EACE,uCAAuC;AACzC","sourcesContent":[".responseScreen {\n  /* width: 100vw;\n  height: 100vh;\n  top: 0px;\n  left: 0px; */\n  font-size: 1.5rem;\n  display: flex;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  cursor: auto;\n  margin-top: 10vh;\n}\n\n.phrase-identification-header {\n  z-index: 9999999;\n  font-size: xx-large;\n}\n.phrase-identification-clickable-categories {\n  margin: auto;\n  display: flex;\n  flex-direction: row;\n  align-content: space-between;\n  z-index: 9999999;\n}\n\n.phrase-identification-category-item {\n  display: inline-block;\n  padding: 5px;\n  border-radius: 7px;\n  box-sizing: border-box;\n  border: 2px solid rgba(0, 0, 0, 0);\n}\n.phrase-identification-category-item:hover {\n  border-color: black;\n  cursor: pointer;\n}\n\n.phrase-identification-category-title {\n  /* font-size: 1.5em; */\n  font-weight: bold;\n  /* color: black; */\n}\n\n.phrase-identification-item-selected {\n  border-color: black;\n}\n\n.phrase-identification-item-not-selected {\n  border-color: rgba(0, 0, 0, 0);\n}\n\n.phrase-identification-item-correct {\n  background-color: rgba(0, 128, 0, 0.266);\n}\n\n.phrase-identification-item-incorrect {\n  background-color: rgba(255, 0, 0, 0.26);\n}\n\n.scientist-feedback-circle {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  border-color: black;\n  border-width: 2px;\n  border-style: solid;\n  background-color: lightblue;\n  visibility: visible;\n}\n.scientist-feedback-circle-container {\n  display: flex;\n  flex-direction: row;\n  z-index: 9999999;\n  height: 100px;\n\n  position: absolute;\n  bottom: 0;\n  left: calc(50%-50vw);\n}\n\n.scientist-feedback-circle-correct {\n  background-color: rgba(0, 128, 0, 0.266);\n}\n.scientist-feedback-circle-incorrect {\n  background-color: rgba(255, 0, 0, 0.26);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
